export default "__VITE_ASSET__BiXiK7LY__"